<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="contactos-view">
      <div class="page-title" style="background-color: #000;">
        <div class="auto-container">
          <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
        </div>
      </div>
      <div class="contactos-content" style="padding-top:50px;">
        <div class="auto-container">
          <div class="title-group">
            <span class="sectionTitle" v-html="fc_getText(null, 'contactos_secTitle')"></span>
            <div class="subtitulo" v-html="item.subtitulo"></div>
          </div>
          <div class="flex flex-wrap">
            <div class="form-column w-full lg:w-6">
              <div class="contact-form">
                <div class="contact-input">
                  <div class="w-full field required">
                    <InputText class="inputText" :placeHolder="fc_getText(null, 'form_nome')" v-model="form.nome" :class="'w-full' + (v$.form.nome.$errors.length ? ' p-invalid' : '')" />
                    <small v-if="(v$.form.nome.$errors[0])" v-html="v$.form.nome.$errors[0].$message"></small>
                  </div>
                </div>
                <div class="contact-input">
                  <div class="w-full field required">
                    <InputText class="inputText" :placeHolder="fc_getText(null, 'form_email')" v-model="form.email" :class="'w-full' + (v$.form.email.$errors.length ? ' p-invalid' : '')"/>
                    <small v-if="(v$.form.email.$errors[0])" v-html="v$.form.email.$errors[0].$message"></small>
                  </div>
                </div>
                <div class="contact-input">
                  <div class="w-full field required">
                    <InputText class="inputText" :placeHolder="fc_getText(null, 'form_telefone')" v-model="form.telefone" :class="'w-full' + (v$.form.telefone.$errors.length ? ' p-invalid' : '')"/>
                    <small v-if="(v$.form.telefone.$errors[0])" v-html="v$.form.telefone.$errors[0].$message"></small>
                  </div>
                </div>
                <div class="contact-input">
                  <div class="w-full field required">
                    <InputText class="inputText" :placeHolder="fc_getText(null, 'form_empresa')" v-model="form.empresa" />
                    <small v-if="(v$.form.empresa.$errors[0])" v-html="v$.form.empresa.$errors[0].$message"></small>
                  </div>
                </div>
                <div class="contact-input">
                  <div class="w-full field required">
                    <Textarea class="inputTextarea" :placeHolder="fc_getText(null, 'form_mensagem')" rows="3" v-model="form.mensagem" style="resize:none;"/>
                    <small v-if="(v$.form.mensagem.$errors[0])" v-html="v$.form.mensagem.$errors[0].$message"></small>
                  </div>
                </div>
                <div class="contact-input">
                  <button type="button" @click="mt_submitContactosForm()" class="btn-redireciona" v-html="fc_getText(null, 'btn_enviarMensagem')"></button>
                </div>
                <div class="contact-input">
                  <div class="checkCondicoesContactos" style="margin-top:10px; color:white;">
                    <div class="checkCondicoesDados">
                      <input type="checkbox" v-model="checkCondicoesDados" name="checkCondicoesDados" style="vertical-align:middle;" />
                      <a @click="fc_goRoute('politicaDePrivacidade')" class="cursorPointer" v-html="fc_getText(null, 'check_condicoesGerais')"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-6">
              <div class="auto-container">
                <div class="image-column w-full">
                  <img :src="item.imagem" alt="" style="width: 530px; max-height: 600px;">
                </div>
                <div class="image-column w-full" style="padding-top: 10px;">
                  <a :href="item.linkGoogleMaps" target="_blank" style="font-size:17px;" v-html="fc_getText(null, 'verMapa')"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="contactos-infoSection">
        <div class="inner-container">
          <div class="flex flex-wrap">
            <div class="info-block w-full md:w-4">
              <div class="inner-box">
                <div class="icon-box wow fade-zoom"><span class="icon pi pi-map-marker"></span></div>
                <div v-if="(item.moradaArteria != '')" class="text-box" v-html="mt_getMorada()"></div>
              </div>
            </div>
            <div class="info-block w-full md:w-4">
              <div class="inner-box">
                <div class="icon-box wow fade-zoom-2"><span class="icon pi pi-envelope"></span></div>
                <div v-if="(item.email != '')" class="text-box"><a :href="'mailto:'+item.email"> {{ item.email }}</a></div>
                <div v-if="(item.emailAlternativo != '')" class="text-box"><a :href="'mailto:'+item.emailAlternativo">{{ item.emailAlternativo }}</a></div>
              </div>
            </div>
            <div class="info-block w-full md:w-4">
              <div class="inner-box">
                <div class="icon-box wow fade-zoom-3"><span class="icon pi pi-phone"></span></div>
                <div v-if="(item.telefone != '')" class="text-box" v-html="item.telefone"></div>
                <div v-if="(item.chamadaRedeFixa)" class="text-box" v-html="fc_getText(null, 'chamadaRedeFixa')"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { helpers, required, email } from '@vuelidate/validators';
export default {
  setup () { return { v$: useVuelidate() }; },
  components: {},
  data() {
    return {
      loaded: false,
      checkCondicoesDados: false,
      item: {},
      form: {
        nome: null, email: null, telefone: null, empresa: null, mensagem: null
      },
    };
  },
  validations () {
    return {
      form: {
        nome: {
          required: helpers.withMessage(this.fc_getText(null,'form_campoObrigatorio'), required),
        },
        email: {
          required: helpers.withMessage(this.fc_getText(null,'form_campoObrigatorio'), required),
          email: helpers.withMessage(this.fc_getText(null,'form_campoValido'), email),
        },
        telefone: {
          required: helpers.withMessage(this.fc_getText(null,'form_campoObrigatorio'), required),
          telefone: helpers.withMessage(this.fc_getText(null,'form_campoValido'), this.fc_validateTelemovel),
        },
        empresa: {
          required: helpers.withMessage(this.fc_getText(null,'form_campoObrigatorio'), required),
        },
        mensagem: {}
      },
    }
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      setTimeout(() => {
        this.loaded = true;
      }, 400)
    },
    mt_getMorada() {
      let strMorada = this.item.moradaArteria + '</br>' + this.item.moradaCp +  ' ' + this.item.moradaCpAlf;
      strMorada += (this.item.linkGoogleMaps != ''? '<br/><a href="' + this.item.linkGoogleMaps + '" target="_blank" style="font-size:17px;" ><strong>'+ this.fc_getText(null,'mapa')+'</strong></a></p>' : '');
      return strMorada;
    },
    async mt_submitContactosForm() {
      if(!this.checkCondicoesDados) {
        let titulo = this.fc_getText(null,'check_condicoesGerais_titulo');
        let subtitulo = this.fc_getText(null,'check_condicoesGerais_subtitulo');
        this.fc_modalDialog(titulo,subtitulo);
      } else {
        const form_valid = await this.v$.$validate();
        if (form_valid) {
          this.loaded = false;

          let formData = new FormData();
          for (let key in this.form) {
            if (this.form[key] != null) { formData.append(key, this.form[key]); }
          }

          this.fc_fetch({ endpoint: 'ContactoPedido/', method: 'POST', body: formData, formData: true, success: this.mt_formSubmeter_success, error: () => { this.loaded = true; } });
        }
      }
    },
    mt_formSubmeter_success() {
      Object.keys(this.form).forEach(key => {
        this.form[key] = null;
      });
      this.v$.$reset();
      this.checkCondicoesDados = false;
      this.loaded = true;
      let titulo = this.fc_getText(null,'form_enviado_titulo');
      let subtitulo = this.fc_getText(null,'form_enviado_subtitulo');
      this.fc_modalDialog(titulo,subtitulo);
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ContactosPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
  .contactos-content {
    padding:100px 0px;
  }
  .contactos-content .title-group {
    margin-bottom: 30px;
  }
  .contactos-content .contact-form .inputText,
  .contactos-content .contact-form .inputTextarea{
    position: relative;
    display: block;
    width: 100%;
    font-size: 15px;
    line-height: 30px;
    color: #3c4858;
    font-weight: 500;
    padding: 10px 0;
    letter-spacing: .5px;
    border-bottom: 1px solid #cccccc;
    transition: all 300ms ease;
  }
  .contactos-content .contact-form {
    position: relative;
    padding-right: 35px;
  }
  .contactos-content .contact-form .contact-input {
    position: relative;
    margin-bottom: 30px;
  }
  .contactos-content .contact-form .inputText:focus,
  .contactos-content .contact-form .inputTextarea:focus {
    border-bottom: 1px solid #fb4848;
  }
  .contactos-content .image-column img {
    display: inline-block;
    max-width: 100%;
    height: auto;
  }
  .contactos-content .image-column a {
    color: var(--ibase-color);
  }
  .contactos-content .image-column a:hover {
    color: #23527c;
  }
  .contactos-content .checkCondicoesContactos {
    margin-top: 10px;
    color: white;
  }
  .contactos-content .checkCondicoesContactos .checkCondicoesDados a {
    vertical-align: middle;
    margin-right: 5px;
    color: var(--ibase-color);
  }
  .contactos-content .checkCondicoesContactos .checkCondicoesDados a:hover {
    text-decoration: underline;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #c0c0c0;
    position: relative;
    margin-right: 10px;
    cursor: pointer;
  }
  input[type="checkbox"]:checked::after {
    content: '✔';
    font-size: 15px;
    color: var(--ibase-color);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contactos-infoSection {
    background-color: #f9f9f9 !important;
    position: relative;
    padding: 75px 0 25px;
  }
  .contactos-infoSection .inner-container {
    max-width: 1060px;
    margin: 0 auto;
    padding: 0 15px;
  }
  .contactos-infoSection .info-block {
    position: relative;
    margin-bottom: 50px;
  }
  .contactos-infoSection .info-block .inner-box {
    position: relative;
    text-align: center;
  }
  .contactos-infoSection .info-block .icon-box {
    position: relative;
    display: inline-block;
    height: 135px;
    width: 135px;
    border-radius: 50%;
    text-align: center;
    font-size: 48px;
    color: #ffffff;
    line-height: 135px;
    background-color: black;
    margin-bottom: 25px;
    transition: all 300ms ease;
  }
  .contactos-infoSection .info-block .text-box {
    display: block;
    font-size: 14px;
    line-height: 25px;
    color: #3c4858;
    font-weight: 500;
  }
  .contactos-infoSection .info-block p {
    display: block;
    font-size: 14px;
    line-height: 25px;
    color: #3c4858;
    font-weight: 500;
  }
  @media only screen and (max-width: 1140px) {
    .contactos-content .contact-form {
      padding-right: 0;
      margin-bottom: 40px;
    }
  }
</style>
